const SEBOT_TOKEN_RE = /\bsebot(?:-wa)?\b/i;

type SebotEventLike = {
  request?: {
    headers?: Record<string, string>;
  };
  contexts?: {
    browser?: {
      name?: string;
    };
  };
};

export function isSEBotEvent(event: unknown): boolean {
  if (event === null || typeof event !== 'object') {
    return false;
  }

  const candidate = event as SebotEventLike;

  const headers = candidate.request?.headers;
  if (headers) {
    for (const value of Object.values(headers)) {
      if (typeof value === 'string' && SEBOT_TOKEN_RE.test(value)) {
        return true;
      }
    }
  }

  const browserName = candidate.contexts?.browser?.name;
  return typeof browserName === 'string' && SEBOT_TOKEN_RE.test(browserName);
}
